import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

export type QuoteRequestLineDto = ClientInferResponseBody<
  typeof contract.quoteRequestLines.findOne
>;

export const fetchQuoteRequestLine = async ({
  id,
}: {
  id: string | undefined;
}): Promise<QuoteRequestLineDto | null> => {
  if (!id) {
    return null;
  }

  const response = await api.quoteRequestLines.findOne.query({
    params: {
      id,
    },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
